export const GoogleMapApiConfig = 'AIzaSyBXig4QTvTOYUQdoY3VfS6vo83DgJ3Dpbw';